/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Routes } from '@angular/router';
import { provideMidasAdminDataAccess } from '@midas/overview/data-access';
import {
  OverviewActionsGuard,
  OverviewCartsGuard,
  OverviewLocationsGuard,
  OverviewStatisticsGuard,
  OverviewWitnessGuard,
} from './guards';

export const OVERVIEW_SHELL_ROUTES: Routes = [
  {
    path: '',
    providers: [provideMidasAdminDataAccess()],
    loadComponent: () => import('./overview-shell/overview-shell.component'),
    children: [
      {
        path: '',
        loadComponent: () => import('./overview-landing-page/overview-landing-page.component'),
      },
      {
        path: 'views',
        canMatch: [OverviewCartsGuard],
        loadComponent: () => import('./overview-views/overview-views.component'),
      },
      {
        path: 'locations',
        canMatch: [OverviewLocationsGuard],
        loadComponent: () => import('./location/location/location.component'),
      },
      {
        path: 'statistics',
        canMatch: [OverviewStatisticsGuard],
        loadComponent: () => import('./overview-statistics/overview-statistics.component'),
      },
      {
        path: 'anytimewitness',
        canMatch: [OverviewWitnessGuard],
        loadComponent: () => import('./overview-anytime-witness/overview-anytime-witness.component'),
      },
      {
        path: 'actions',
        canMatch: [OverviewActionsGuard],
        loadComponent: () => import('./overview-actions/overview-actions.component'),
      },
    ],
  },
];
